import validatorMethods from '@tcp/core/src/utils/formValidation/validatorMethods';
import { PAYMENT_METHODS_WITHOUT_CARD_NUMBER } from '../../../../Checkout/Checkout.constants';
import { ALL_PAYMENT_TYPE_IMAGES } from '../../../container/SinglePageCheckout.constants';

export const formatMonthAndYear = (expMonth, expYear) => {
  const month = +expMonth < 10 ? `0${expMonth}` : expMonth;
  const year = expYear && expYear.toString().slice(2, 4);
  return `${month}/${year}`;
};

export const formatAmount = (value, currencySymbol) => {
  let val = value;
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(val)) {
    val = 0;
  }
  const symbol = val < 0 ? '-' : '';
  return symbol + currencySymbol + Math.abs(val).toFixed(2);
};

export const getCardImageDetails = (cardType = '') => {
  const cardTypeDetails = ALL_PAYMENT_TYPE_IMAGES.find(
    (item) => item.key.toUpperCase() === cardType.toUpperCase()
  );
  return cardTypeDetails || {};
};

export const getCardDetails = (cardDetails) => {
  const { cardNumber = '', expMonth = '', expYear = '' } = cardDetails;
  const formattedDate = formatMonthAndYear(expMonth, expYear);
  return {
    cardNumber,
    formattedDate,
  };
};

export const getPaymentCollapsedDetails = (billingData) => {
  const { billing, paymentMethod } = billingData;
  let cardDetails = {};
  let cardType;

  if (billing) {
    ({ cardType = '' } = billing);
    cardDetails = getCardDetails(billing);
  } else if (PAYMENT_METHODS_WITHOUT_CARD_NUMBER.includes(paymentMethod)) {
    cardType = paymentMethod;
  }
  if (cardType?.toLowerCase().includes('place')) {
    cardType = 'PLACE CARD_PJP';
  }
  const cardImageDetails = getCardImageDetails(cardType);

  return {
    ...cardImageDetails,
    ...cardDetails,
  };
};

export const isCardExpired = (expMonth = '', expYear = '') => {
  if (!expMonth && !expYear) {
    return false;
  }
  const formattedExpMonth = String(expMonth).padStart(2, '0');
  const formattedExpYear = String(expYear).slice(-2);
  return !validatorMethods.creditCardDate(`${formattedExpMonth}/${formattedExpYear}`);
};
